module.exports = __webpack_public_path__ + "img/IMG_9911.3ecfdeaf.jpg";